import type { DataAlterationGuardVerdict } from './data-alteration-guard.types'

export const ALLOWED: DataAlterationGuardVerdict = {
  confirmed: true,
  skipUnprepare: false,
}

export const REFUSED: DataAlterationGuardVerdict = {
  confirmed: false,
  skipUnprepare: false,
}

// A decider names itself on <html> so a caller can tell, without waiting,
// whether anybody will answer its guard. No name means no decider, and the
// caller may proceed.
export const GUARD_MARKER = 'alterationGuard'
